import useBackdrop from '../../Hooks/useBackdrop';
import { fetchAuthSession } from 'aws-amplify/auth';
import useStore from '../../Hooks/useStore';
import { logger } from '../../utils/logger';

export const formatCapitalizeWord = (value) => {
  const excludedWords = ['of', 'and', 'by'];
  if (!value) {
    return '';
  }

  // Split camelCase string into words
  const words = value
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before uppercase letters
    .split(/[_\s-]+/); // Split by underscore, space, or dash

  const formattedWords = words.map((word) => {
    return excludedWords.includes(word.toLowerCase())
      ? word.toLowerCase()
      : word.charAt(0).toUpperCase() + word.slice(1);
  });

  return formattedWords.join(' ');
};

export const convertObjectToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => {
    return { assessmentItemId: key, answer: value };
  });
};

export function isEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }

  if (typeof obj1 !== typeof obj2 || obj1 === null || obj2 === null) {
    return false;
  }

  if (typeof obj1 !== 'object' || obj1 instanceof Date) {
    return obj1 === obj2;
  }

  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }

  return obj1Keys.every((key) => isEqual(obj1[key], obj2?.[key]));
}

export function formatCurrency(number) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return formatter.format(number);
}

export async function layoutLoader() {
  useBackdrop.getState().showBackdrop();
  try {
    const session = await fetchAuthSession();
    const token = session.tokens.accessToken;

    useStore.getState().setToken(token);
    await useStore.getState().fetchUser();
    useBackdrop.getState().hideBackdrop();
    return 'loaded';
  } catch (error) {
    logger.error('Error fetching session data', error);
    throw error;
  }
}

export const joinClassNames = (...classes) => classes.filter(Boolean).join(' ');
